import React from 'react';
import { Link } from 'react-router-dom';

/**
 * A player projected to a draft pick: a link for a real player, or a plain
 * italic placeholder (e.g. "Rookie WR1") for an unnamed rookie. A dash when
 * nobody is projected.
 */
const ProjectedPlayer = ({ player }) => {
    if (!player) {
        return '—';
    }
    if (player.isRookie) {
        return (
            <>
                <em>{player.name}</em>{' '}
                <span className="badge bg-info text-dark">Rookie</span>
            </>
        );
    }
    return (
        <>
            <Link to={`/player/${player.id}`}>{player.name}</Link>{' '}
            <span className="text-light opacity-75 small">{player.posname}</span>
        </>
    );
};

export default ProjectedPlayer;
